<script>

import { Doughnut } from 'vue-chartjs'

export default {
  extends: Doughnut,

  props: {
    chartData: { type: Object },
    chartOptions: { type: Object }
  },

  data() {
    return {
      toolTipDelay: { delay: { "show": 500, "hide": 100 } },
      currentWidth: undefined,
      data: {
        labels: ['Pro', 'Neutral', 'Con'],
        datasets: [
          {
            backgroundColor: ['green', 'yellow', 'red'],
            data: [5, 2, 1],
            // borderColor: 'rgba(51, 51, 51, 0.7)',
            // pointBackgroundColor: ['#ff1500', '#ffd800', '#4cff00', '#ff1500', '#ffd800', '#4cff00', '#ff1500'],
            // pointBorderColor: ['#ff1500', '#ffd800', '#4cff00', '#ff1500', '#ffd800', '#4cff00', '#ff1500'],
            // pointRadius: 4,
            // pointHoverRadius: 5,
						// fill: false,
          }
        ]
      },
      options: {
        legend: { display: false },
        animation: {
          duration: 1,
          animateRotate: true,
          animateScale: true
        },
        hover: { animationDuration: 0 },
        cutoutPercentage: 66,
        responsive: true,
        responsiveAnimationDuration: 0,
        maintainAspectRatio: true,
        layout: {
          padding: {
            right: 0,
            top: 0,
            bottom: 0,
            left: 0
          }
        },
      }
    };
  },

  methods: {
    update() {
      this.$data._chart.update()
    }
  },

  watch: {
    chartData: function () {
      this.update();
    }
  },

  mounted () {
    if (this.chartData) {
      this.data = this.chartData;
    }
    if (this.chartOptions) {
      this.options = this.chartOptions;
    }
    this.renderChart(this.data, this.options);
  }

};

</script>
